import { cn } from "../lib/utils";

export interface ToggleProps {
  checked: boolean;
  onCheckedChange: (next: boolean) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
}

export function Toggle({
  checked,
  onCheckedChange,
  label,
  disabled,
  className,
}: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={cn(
        "inline-flex items-center gap-1.5 text-[11px]",
        disabled && "opacity-50 cursor-not-allowed",
        className,
      )}
    >
      <span
        className={cn(
          "relative w-7 h-[15px] rounded-pill transition-colors",
          checked ? "bg-success" : "bg-border-strong",
        )}
      >
        <span
          className="absolute top-[2px] w-[11px] h-[11px] rounded-pill bg-surface transition-[left]"
          style={{ left: checked ? 14 : 2 }}
        />
      </span>
      {label && (
        <span
          className={cn(
            "font-medium",
            checked ? "text-success" : "text-ink-subtle",
          )}
        >
          {label}
        </span>
      )}
    </button>
  );
}
